import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const SubtractIcon = ({ size, ...props }) => (
  <SvgIcon {...props} sx={{ width: size, height: size, ...(props?.sx ?? {}) }}>
    <path
      d="M20 10.9998H4C3.448 10.9998 3 11.4478 3 11.9998C3 12.5518 3.448 12.9998 4 12.9998H20C20.552 12.9998 21 12.5518 21 11.9998C21 11.4478 20.552 10.9998 20 10.9998Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

SubtractIcon.propTypes = {
  size: PropTypes.string,
  sx: PropTypes.object,
};

export default SubtractIcon;
